/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateKeyValueRequest
 */
export interface UpdateKeyValueRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateKeyValueRequest
     */
    value?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateKeyValueRequest
     */
    expires?: Date | null;
}

/**
 * Check if a given object implements the UpdateKeyValueRequest interface.
 */
export function instanceOfUpdateKeyValueRequest(value: object): value is UpdateKeyValueRequest {
    return true;
}

export function UpdateKeyValueRequestFromJSON(json: any): UpdateKeyValueRequest {
    return UpdateKeyValueRequestFromJSONTyped(json, false);
}

export function UpdateKeyValueRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateKeyValueRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'expires': json['expires'] == null ? undefined : (new Date(json['expires'])),
    };
}

export function UpdateKeyValueRequestToJSON(json: any): UpdateKeyValueRequest {
    return UpdateKeyValueRequestToJSONTyped(json, false);
}

export function UpdateKeyValueRequestToJSONTyped(value?: UpdateKeyValueRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'expires': value['expires'] == null ? value['expires'] : value['expires'].toISOString(),
    };
}

